import React, { Component } from 'react';
import './App.css';
import Simplify360Chat from './Simplify360Chat/Simplify360Chat';
import HWLogsDisplay from './Simplify360Chat/HWLibrary/HWLogsDisplay';
import {s360ConfigService} from "./Simplify360Chat/Services/S360Config";
import { watchForChatSDKEvents, fetchConfigDetailsFromClientHost } from './Simplify360Chat/Services/HWIframeBridge';

class App extends Component {

  constructor(props) {
    super(props);
    s360ConfigService.loadClientConfigFromToken();
    watchForChatSDKEvents(this, () => {  })
  }

  render() {
    return (
      <>
        {/* <HWLogsDisplay/>  */}
        {console.log("app")}
        {s360ConfigService.isConfigured() && < Simplify360Chat {...this.state}/>}
      </>
    )
  }

  componentDidMount() {
    fetchConfigDetailsFromClientHost();
  }

}

export default App;